// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SelectListHeaderChipGroup-base__ONh5N{display:flex;flex-wrap:wrap;gap:var(--size-2);align-items:center;padding:var(--size-4) var(--size-4) 0}.SelectListHeaderChipGroup-base__ONh5N:last-child{padding-bottom:var(--size-4);border-bottom:var(--size-0_25) solid var(--gray-a4)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "SelectListHeaderChipGroup-base__ONh5N"
};
export default ___CSS_LOADER_EXPORT___;
